








import Vue from 'vue';

export default Vue.extend({
  name: 'JerseyLoading',
  data() {
    return { value: '' };
  },
  props: { title: String },
  mounted() {},
});
